const customStyles = {
  table: {
    style: {
      width: '100%',
    },
  },
  headRow: {
    style: {
      fontWeight: 'bold',
      borderBottom: '1px solid #5426b2',
      color: '#495057',
      justifyContent: 'center',
    },
  },
  headCells: {
    style: {
      justifyContent: 'center',
      paddingLeft: '28px',
    },
  },
  cells: {
    style: {
      justifyContent: 'center',
      alignItem: 'center',
      borderColor: '#5426b2',
      paddingTop: '10px',
      paddingBottom: '10px',
    },
  },

  // rows: {
  //   style: {
  //     '&:hover': {
  //       backgroundColor: '#e0d6f0',
  //       transitionDuration: '0.15s',
  //       transitionProperty: 'background-color, color',
  //       borderBottomColor: '#e0f7fa',
  //       outlineStyle: 'solid',
  //       outlineWidth: '1px',
  //       outlineColor: '#e0f7fa',
  //     },
  //   },
  // },
};

export default customStyles;
